import { VIMMetrics } from "@domains/VIM/slices/vim.slice";
import { logVIMUpdatePrice } from "@domains/VIM/utils/logVimPrice";

// interfaces.
import {
  PredictionPublicationPrice,
  VimDataLog,
} from "@domains/VIM/interfaces/interfaces";
import { InventoryPricingModel } from "@store/apiSlices/inventoryPricing/inventoryPricing.endpoints";
import { InventorySummaryForm } from "../../InventorySummaryCO/InventorySummaryCO";

interface UseInventorySubmitParams {
  handlePostInventoryPricing: (payload: InventoryPricingModel) => void;
  handleVIMLog: (params: VimDataLog) => void;
  inventoryPriceType: string;
  nidSelected: number | string;
  selectedOption: PredictionPublicationPrice | null;
  suggestionOption: PredictionPublicationPrice | null;
  user: { country?: string; email: string };
  vimMetrics: VIMMetrics;
}

export const useInventorySubmit = ({
  handlePostInventoryPricing,
  handleVIMLog,
  user,
  nidSelected,
  vimMetrics,
  selectedOption,
  suggestionOption,
  inventoryPriceType,
}: UseInventorySubmitParams) => {
  const onSubmit = (data: InventorySummaryForm) => {
    const publicationPrice = Number(data.publicationPrice);
    const minPublicationPrice = Number(data.minPublicationPrice);

    // Red de seguridad: nunca enviar precios inválidos o no positivos al
    // backend (aunque la validación de campo fallara o quedara sin ejecutarse).
    if (
      !Number.isFinite(publicationPrice) ||
      publicationPrice <= 0 ||
      !Number.isFinite(minPublicationPrice) ||
      minPublicationPrice <= 0
    ) {
      return;
    }

    handlePostInventoryPricing({
      agent: user.email,
      comment: data.commentInput,
      commission: data.commissionPercentage.toString(),
      country: user.country,
      current_utility: data.utilityCurrent || 0,
      initial_utility: data.utilityInitial || 0,
      leader_approval: data.leader,
      min_publication_price: minPublicationPrice,
      nid: Number(nidSelected),
      price_type: inventoryPriceType,
      publication_price: publicationPrice,
      status: "completed",
    });
    logVIMUpdatePrice({
      data: {
        minPublicationPrice: minPublicationPrice,
        publicationPrice: publicationPrice,
      },
      handleVIMLog,
      nidSelected: Number(nidSelected),
      selectedOption,
      suggestionOption,
      user,
      vimMetrics,
    });
  };

  return { onSubmit };
};
